import { MaintenanceModalInfo } from "../components/content/user-info/ModalInfo";

export const getContentModal = (contentModal)=>{
  const isMaintenanceMode = JSON.parse(process.env.REACT_APP_IS_MAINTENANCE_MODE);

  if(isMaintenanceMode) {
    return MaintenanceModalInfo
  }

  return contentModal
}